export const CENTRAL_TENANT_FALLBACK_NAME = "Your funeral home";

export function resolveCentralTenantBrandIdentity(configuredName: string | null, settingsResolved: boolean) {
  const authoritativeName = settingsResolved ? configuredName?.trim() ?? "" : "";
  const name = authoritativeName || CENTRAL_TENANT_FALLBACK_NAME;
  return {
    name,
    shortName: authoritativeName ? centralTenantShortName(name) : CENTRAL_TENANT_FALLBACK_NAME,
    useBundledMonarchLogo: Boolean(authoritativeName && /^monarch\b/i.test(authoritativeName)),
  };
}

export function centralTenantShortName(name: string) {
  const normalized = name.trim().replace(/\s+/g, " ");
  if (!normalized) return CENTRAL_TENANT_FALLBACK_NAME;
  const shortName = normalized.split(/\s+(?:Funeral|Mortuary|Cremation|Memorial)\b/i)[0]?.trim();
  return shortName || normalized;
}
